import { Helmet } from "react-helmet";

function SEO({ title, description,  url }) {
  return (
    <Helmet>
      {/* Dynamic Meta Titles */}
      <title>{title || "PPDDEH – Learn Hacking & Coding"}</title>
      <meta name="title" content={title || "Learn Hacking & Programming Online – Free Courses at PPDDEH"} />

      {/* Dynamic Meta Descriptions */}
      <meta name="description" content={description || "Master hacking and programming online for free with PPDDEH. Access expert-led courses on cybersecurity, coding, and ethical hacking today!"} />

      {/* Dynamic Meta Keywords */}
      <meta name="keywords" content="learn hacking, ethical hacking, ethical hacking tutorials, free coding tutorials, programming for beginners, coding lessons, cybersecurity basics, web development tutorials, AMV creation, music mixing, music video editing, video editing tips, online hacking courses, hacking tools, cybersecurity online, digital skills learning, music production, best coding languages, tech tutorials, free programming courses, ethical hacking tools, how to create AMVs, music production techniques, web development for beginners, learn ethical hacking for free" />

      {/* Open Graph / Social Media Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title || "PPDDEH – Learn Hacking & Coding"} />
      <meta property="og:description" content={description || "Join PPDDEH to learn ethical hacking, coding, and more!"} />
      <meta property="og:image" content="https://www.ppddeh.com/static/media/logo.png" />
      <meta property="og:url" content={url || "https://www.ppddeh.com/"} />
    </Helmet>
  );
}

export default SEO;
